"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCancelButton = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = require("../Button");
var _templateObject;
var StyledCancelButton = exports.StyledCancelButton = (0, _styledComponents["default"])(_Button.Button)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n  margin-left: 16px;\n\n  &:hover,\n  &:active {\n    color: #000000 !important;\n    background-color: #ffffff !important;\n  }\n  &:focus {\n    background-color: #ffffff;\n    box-shadow: 0 0 0 0.0625rem #0095ff;\n  }\n"])));